// submenu-position-plugin.js
export default {
  install(app) {
    let observer = null;
    const processedSubmenus = new WeakSet();
    
    const positionSubmenu = (submenu) => {
      if (!submenu || submenu.offsetParent === null) return;
      
      // Prevent multiple rapid repositioning
      if (processedSubmenus.has(submenu)) return;
      processedSubmenus.add(submenu);
      
      // Use requestAnimationFrame to position before paint
      requestAnimationFrame(() => {
        const rect = submenu.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        
        // Only reposition if it actually overflows
        if (rect.bottom > viewportHeight - 10) {
          // Add transition prevention class
          submenu.classList.add('positioning');
          
          // Reset and reposition
          submenu.style.top = 'auto';
          submenu.style.bottom = '0';
          submenu.style.transform = 'translateY(0)';
          
          // Remove positioning class after a frame
          setTimeout(() => {
            submenu.classList.remove('positioning');
            processedSubmenus.delete(submenu);
          }, 16);
        } else {
          processedSubmenus.delete(submenu);
        }
      });
    };
    
    const setupObserver = () => {
      if (observer) observer.disconnect();
      
      observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          // Watch for new context menus
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1 && node.classList?.contains('p-contextmenu')) {
                setTimeout(() => setupContextMenu(node), 0);
              }
            });
          }
          
          // Watch for submenu visibility changes (but with debouncing)
          if (mutation.type === 'attributes' && 
              mutation.attributeName === 'style' &&
              mutation.target.classList?.contains('p-submenu-list')) {
            const submenu = mutation.target;
            
            // Only process if submenu is becoming visible
            if (submenu.offsetParent !== null && !processedSubmenus.has(submenu)) {
              positionSubmenu(submenu);
            }
          }
        });
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
      });
    };
    
    const setupContextMenu = (contextMenu) => {
      const menuItems = contextMenu.querySelectorAll('.p-menuitem');
      
      menuItems.forEach((item) => {
        const submenu = item.querySelector('.p-submenu-list');
        if (submenu) {
          // Use mouseenter with immediate positioning
          item.addEventListener('mouseenter', () => {
            if (!processedSubmenus.has(submenu)) {
              positionSubmenu(submenu);
            }
          });
          
          // Clean up when submenu hides
          item.addEventListener('mouseleave', () => {
            setTimeout(() => {
              if (submenu.offsetParent === null) {
                processedSubmenus.delete(submenu);
                submenu.style.top = '';
                submenu.style.bottom = '';
                submenu.style.transform = '';
              }
            }, 100);
          });
        }
      });
    };
    
    // Add CSS to prevent transitions during positioning
    const style = document.createElement('style');
    style.textContent = `
      .p-submenu-list.positioning {
        transition: none !important;
        animation: none !important;
      }
    `;
    document.head.appendChild(style);
    
    // Initialize on app mount
    app.mixin({
      mounted() {
        if (!observer) {
          setupObserver();
          
          // Handle existing context menus
          document.querySelectorAll('.p-contextmenu').forEach(setupContextMenu);
        }
      }
    });
    
    // Cleanup
    if (typeof window !== 'undefined') {
      window.addEventListener('beforeunload', () => {
        if (observer) observer.disconnect();
      });
    }
  }
};